<template lang="pug">
  v-sheet.pa-2.px-0.text-center(
    style="width: 85px"
    :color="$theme.backgroundLight.color")
    div
      strong {{ value }}
    div(style="font-size: 12px") {{ $pluralize({ word: label, count: value, hideCount: true }) }}
</template>

<script>
import { injectRouteState } from '@iez/core'
import data from '@iez/lib/data/'
import { computed } from '@vue/composition-api'

export default {
  setup () {
    const routeState = injectRouteState()
    const user = data.get({
      root: `users`,
      one: true,
      request: () => ({
        where: {
          id: {
            _eq: routeState.user?.id
          }
        }
      }),
      fields: [
        `id`, {
          followsUsersFollowers: [
            `id`
          ]
        }
      ]
    })

    const value = computed(
      () => user.value?.followsUsersFollowers?.length ?? 0
    )

    return {
      user,
      value,
      label: `abonné`
    }
  }
}
</script>
